// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container matching Dashboard gradient */
.admin-employees-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

.center-content {
    justify-content: center;
    align-items: center;
}

.loading-text {
    margin-top: 1.5rem;
    font-size: 1.2rem;
    color: #475569;
    font-weight: 500;
}

/* === HEADER === */
.groups-header {
    margin-bottom: 1.5rem;
}

.elder-back-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: white;
    border: 1px solid #cbd5e1;
    padding: 0.6rem 1rem;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.elder-back-btn:hover {
    background: #f1f5f9;
    border-color: #94a3b8;
    color: #1e293b;
}

.page-title {
    margin: 0;
    font-size: 1.5rem;
    color: #1e293b;
    font-weight: 800;
}

/* === MAIN CONTENT === */
.employees-main-content {
    padding: 0 2rem 4rem 2rem;
    max-width: 1000px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

/* === CONTROL PANEL (Search) === */
.employees-control-panel {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 2.5rem;
    background: white;
    padding: 1rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.admin-search-form {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex: 1 1;
    max-width: 500px;
}

.admin-search-input-wrapper {
    display: flex;
    align-items: center;
    flex: 1 1;
    background: white;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    padding: 0 0.75rem;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.admin-search-input-wrapper:focus-within {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.admin-search-icon {
    color: #94a3b8;
    flex-shrink: 0;
}

.admin-search-input {
    flex: 1 1;
    border: none;
    background: transparent;
    padding: 0.75rem 0.5rem;
    font-size: 1rem;
    color: #1e293b;
    outline: none;
    min-width: 0;
}

.admin-search-input::placeholder {
    color: #94a3b8;
}

.admin-search-submit-btn {
    background: #3b82f6;
    color: white;
    border: none;
    padding: 0.75rem 1.25rem;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
    flex-shrink: 0;
}

.admin-search-submit-btn:hover {
    background: #2563eb;
}

/* === LIST SECTION === */
.section-header-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;
    flex-wrap: wrap;
    gap: 0.75rem;
}

.elder-section-title {
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 700;
    margin: 0;
    padding-left: 0.25rem;
}

.total-count-badge {
    background: #f1f5f9;
    color: #475569;
    padding: 0.4rem 1rem;
    border-radius: 99px;
    font-weight: 700;
    font-size: 0.9rem;
    border: 1px solid #e2e8f0;
    white-space: nowrap;
}

.elder-list-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.elder-list-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.5rem;
    transition: all 0.2s ease;
}

.clickable-card {
    cursor: pointer;
}

.clickable-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
    border-color: #bfdbfe;
}

.clickable-card:hover .view-history-btn {
    color: #2563eb;
}

.clickable-card:hover .view-history-btn svg {
    transform: translateX(4px);
}

.list-card-left {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    flex: 1 1;
    min-width: 0;
}

.icon-wrapper {
    height: 56px;
    width: 56px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.icon-slate {
    background: #f1f5f9;
    color: #475569;
}

.icon-navy {
    background: #e0e7ff;
    color: #3730a3;
}

.list-card-info {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    flex: 1 1;
    min-width: 0;
}

.title-with-role {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
}

.elder-card-title {
    margin: 0;
    font-size: 1.25rem;
    color: #1e293b;
    font-weight: 700;
    word-break: break-word;
}

.role-badge {
    font-size: 0.75rem;
    padding: 0.2rem 0.6rem;
    border-radius: 99px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.badge-admin {
    background: #e0e7ff;
    color: #4338ca;
    border: 1px solid #c7d2fe;
}

.badge-emp {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #cbd5e1;
}

.person-details-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.detail-text {
    font-size: 1.05rem;
    color: #64748b;
    font-weight: 500;
}

/* Actions Right Side */
.list-card-right {
    flex-shrink: 0;
}

.view-history-btn {
    background: transparent;
    border: none;
    color: #64748b;
    font-size: 1.05rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: color 0.2s;
}

.view-history-btn svg {
    transition: transform 0.2s;
}

/* Empty States & Loading */
.elder-empty-card {
    background: white;
    border-radius: 16px;
    padding: 4rem 2rem;
    text-align: center;
    font-size: 1.2rem;
    color: #64748b;
    border: 2px dashed #cbd5e1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.empty-icon-wrapper {
    height: 80px;
    width: 80px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
}

/* === PAGINATION === */
.elder-pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
    background: white;
    padding: 1rem 1.5rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.page-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: #f1f5f9;
    border: none;
    color: #334155;
    padding: 0.75rem 1.25rem;
    border-radius: 12px;
    font-size: 1.1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
    background: #e2e8f0;
    color: #1e293b;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-info {
    font-size: 1.1rem;
    color: #475569;
    font-weight: 600;
}

/* =========================================
   === SLIDE-OUT HISTORY PANEL ===
   ========================================= */
.history-panel-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.4);
    backdrop-filter: blur(2px);
    z-index: 1000;
}

.history-slide-panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 450px;
    max-width: 100vw;
    background: #f8fafc;
    z-index: 1001;
    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    animation: slideInRight 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes slideInRight {
    from {
        transform: translateX(100%);
    }

    to {
        transform: translateX(0);
    }
}

.history-panel-header {
    background: white;
    padding: 2rem 1.5rem;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.panel-header-info h2 {
    margin: 0 0 0.5rem 0;
    font-size: 1.5rem;
    color: #1e293b;
    font-weight: 800;
}

.panel-header-info p {
    margin: 0;
    font-size: 1rem;
    color: #64748b;
    font-weight: 500;
}

.panel-close-btn {
    background: #f1f5f9;
    border: none;
    color: #64748b;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}

.panel-close-btn:hover {
    background: #e2e8f0;
    color: #1e293b;
}

.history-panel-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
}

.history-section-title {
    margin: 0 0 1.5rem 0;
    font-size: 1.1rem;
    color: #475569;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.history-empty {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #94a3b8;
    text-align: center;
    gap: 1rem;
}

.history-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.history-tx-card {
    background: white;
    border-radius: 12px;
    padding: 1.25rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.history-tx-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
}

.history-tx-icon {
    height: 40px;
    width: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.bg-blue-light {
    background: #eff6ff;
}

.bg-green-light {
    background: #f0fdf4;
}

.text-blue {
    color: #2563eb;
}

.text-green {
    color: #059669;
}

.history-tx-main {
    flex: 1 1;
}

.history-tx-main h4 {
    margin: 0 0 0.2rem 0;
    font-size: 1.05rem;
    color: #1e293b;
    font-weight: 700;
}

.tx-date {
    font-size: 0.85rem;
    color: #64748b;
}

.history-tx-amount {
    font-size: 1.2rem;
    font-weight: 800;
}

.history-tx-details {
    background: #f8fafc;
    border-radius: 8px;
    padding: 1rem;
    font-size: 0.95rem;
}

.history-tx-details p {
    margin: 0 0 0.4rem 0;
    color: #334155;
}

.history-tx-details p:last-child {
    margin: 0;
}

.history-tx-details strong {
    color: #64748b;
    font-weight: 600;
}

.history-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid #e2e8f0;
    font-weight: 600;
    color: #475569;
}

/* === RESPONSIVE FOR MOBILE === */
@media (max-width: 768px) {
    .groups-header {
        padding: 1.25rem;
    }

    .employees-main-content {
        padding: 0 1rem 3rem 1rem;
    }

    .employees-control-panel {
        justify-content: stretch;
    }

    .admin-search-form {
        max-width: 100%;
        width: 100%;
    }

    .elder-list-card {
        flex-direction: column;
        align-items: stretch;
        padding: 1.25rem;
        gap: 1.25rem;
    }

    .list-card-left {
        width: 100%;
    }

    .list-card-right {
        width: 100%;
        border-top: 1px solid #f1f5f9;
        padding-top: 1.25rem;
    }

    .view-history-btn {
        width: 100%;
        justify-content: space-between;
    }

    .elder-pagination {
        flex-direction: column;
        gap: 1.5rem;
    }

    .page-btn {
        width: 100%;
        justify-content: center;
    }
}


/* === NEW: ADMIN TRANSFER HUB CARD === */
.admin-transfer-hub-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid #a7f3d0;
    box-shadow: 0 4px 10px rgba(16, 185, 129, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 2.5rem;
    transition: all 0.2s ease;
}

.admin-transfer-hub-card:hover {
    box-shadow: 0 10px 15px -3px rgba(16, 185, 129, 0.2);
    border-color: #34d399;
}

.hub-card-left {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    flex: 1 1;
}

.hub-card-info h2 {
    margin: 0 0 0.25rem 0;
    font-size: 1.4rem;
    color: #064e3b;
    font-weight: 800;
}

.hub-card-info p {
    margin: 0;
    color: #059669;
    font-size: 1.05rem;
}

.bg-emerald-light {
    background: #ecfdf5;
}

.text-emerald {
    color: #059669;
}

@media (max-width: 768px) {
    .admin-transfer-hub-card {
        flex-direction: column;
        align-items: stretch;
        padding: 1.25rem;
    }

    .hub-card-right {
        display: flex;
        justify-content: flex-end;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/Employees.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,0CAA0C;IAC1C,8CAA8C;IAC9C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,2BAA2B;AAC3B;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;8CAE8C;AAC9C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,mEAAmE;AACvE;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;AAClB;;AAEA,kCAAkC;AAClC;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,6BAA6B;QAC7B,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ;;;AAGA,yCAAyC;AACzC;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;IAC9C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,oDAAoD;IACpD,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,yBAAyB;IAC7B;AACJ","sourcesContent":["/* Container matching Dashboard gradient */\n.admin-employees-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n.center-content {\n    justify-content: center;\n    align-items: center;\n}\n\n.loading-text {\n    margin-top: 1.5rem;\n    font-size: 1.2rem;\n    color: #475569;\n    font-weight: 500;\n}\n\n/* === HEADER === */\n.groups-header {\n    margin-bottom: 1.5rem;\n}\n\n.elder-back-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: white;\n    border: 1px solid #cbd5e1;\n    padding: 0.6rem 1rem;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.2s;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.elder-back-btn:hover {\n    background: #f1f5f9;\n    border-color: #94a3b8;\n    color: #1e293b;\n}\n\n.page-title {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n/* === MAIN CONTENT === */\n.employees-main-content {\n    padding: 0 2rem 4rem 2rem;\n    max-width: 1000px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* === CONTROL PANEL (Search) === */\n.employees-control-panel {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 2.5rem;\n    background: white;\n    padding: 1rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.admin-search-form {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex: 1;\n    max-width: 500px;\n}\n\n.admin-search-input-wrapper {\n    display: flex;\n    align-items: center;\n    flex: 1;\n    background: white;\n    border: 1px solid #cbd5e1;\n    border-radius: 10px;\n    padding: 0 0.75rem;\n    transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.admin-search-input-wrapper:focus-within {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.admin-search-icon {\n    color: #94a3b8;\n    flex-shrink: 0;\n}\n\n.admin-search-input {\n    flex: 1;\n    border: none;\n    background: transparent;\n    padding: 0.75rem 0.5rem;\n    font-size: 1rem;\n    color: #1e293b;\n    outline: none;\n    min-width: 0;\n}\n\n.admin-search-input::placeholder {\n    color: #94a3b8;\n}\n\n.admin-search-submit-btn {\n    background: #3b82f6;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.25rem;\n    border-radius: 10px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s;\n    flex-shrink: 0;\n}\n\n.admin-search-submit-btn:hover {\n    background: #2563eb;\n}\n\n/* === LIST SECTION === */\n.section-header-flex {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.25rem;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n}\n\n.elder-section-title {\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 700;\n    margin: 0;\n    padding-left: 0.25rem;\n}\n\n.total-count-badge {\n    background: #f1f5f9;\n    color: #475569;\n    padding: 0.4rem 1rem;\n    border-radius: 99px;\n    font-weight: 700;\n    font-size: 0.9rem;\n    border: 1px solid #e2e8f0;\n    white-space: nowrap;\n}\n\n.elder-list-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.elder-list-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid rgba(226, 232, 240, 0.8);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1.5rem;\n    transition: all 0.2s ease;\n}\n\n.clickable-card {\n    cursor: pointer;\n}\n\n.clickable-card:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n    border-color: #bfdbfe;\n}\n\n.clickable-card:hover .view-history-btn {\n    color: #2563eb;\n}\n\n.clickable-card:hover .view-history-btn svg {\n    transform: translateX(4px);\n}\n\n.list-card-left {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    flex: 1;\n    min-width: 0;\n}\n\n.icon-wrapper {\n    height: 56px;\n    width: 56px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.icon-slate {\n    background: #f1f5f9;\n    color: #475569;\n}\n\n.icon-navy {\n    background: #e0e7ff;\n    color: #3730a3;\n}\n\n.list-card-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    flex: 1;\n    min-width: 0;\n}\n\n.title-with-role {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex-wrap: wrap;\n}\n\n.elder-card-title {\n    margin: 0;\n    font-size: 1.25rem;\n    color: #1e293b;\n    font-weight: 700;\n    word-break: break-word;\n}\n\n.role-badge {\n    font-size: 0.75rem;\n    padding: 0.2rem 0.6rem;\n    border-radius: 99px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.badge-admin {\n    background: #e0e7ff;\n    color: #4338ca;\n    border: 1px solid #c7d2fe;\n}\n\n.badge-emp {\n    background: #f1f5f9;\n    color: #475569;\n    border: 1px solid #cbd5e1;\n}\n\n.person-details-inline {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.detail-text {\n    font-size: 1.05rem;\n    color: #64748b;\n    font-weight: 500;\n}\n\n/* Actions Right Side */\n.list-card-right {\n    flex-shrink: 0;\n}\n\n.view-history-btn {\n    background: transparent;\n    border: none;\n    color: #64748b;\n    font-size: 1.05rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    transition: color 0.2s;\n}\n\n.view-history-btn svg {\n    transition: transform 0.2s;\n}\n\n/* Empty States & Loading */\n.elder-empty-card {\n    background: white;\n    border-radius: 16px;\n    padding: 4rem 2rem;\n    text-align: center;\n    font-size: 1.2rem;\n    color: #64748b;\n    border: 2px dashed #cbd5e1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.empty-icon-wrapper {\n    height: 80px;\n    width: 80px;\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1rem;\n}\n\n/* === PAGINATION === */\n.elder-pagination {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 2rem;\n    background: white;\n    padding: 1rem 1.5rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.page-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: #f1f5f9;\n    border: none;\n    color: #334155;\n    padding: 0.75rem 1.25rem;\n    border-radius: 12px;\n    font-size: 1.1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.page-btn:hover:not(:disabled) {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n.page-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.page-info {\n    font-size: 1.1rem;\n    color: #475569;\n    font-weight: 600;\n}\n\n/* =========================================\n   === SLIDE-OUT HISTORY PANEL ===\n   ========================================= */\n.history-panel-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.4);\n    backdrop-filter: blur(2px);\n    z-index: 1000;\n}\n\n.history-slide-panel {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 450px;\n    max-width: 100vw;\n    background: #f8fafc;\n    z-index: 1001;\n    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    animation: slideInRight 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n@keyframes slideInRight {\n    from {\n        transform: translateX(100%);\n    }\n\n    to {\n        transform: translateX(0);\n    }\n}\n\n.history-panel-header {\n    background: white;\n    padding: 2rem 1.5rem;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.panel-header-info h2 {\n    margin: 0 0 0.5rem 0;\n    font-size: 1.5rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.panel-header-info p {\n    margin: 0;\n    font-size: 1rem;\n    color: #64748b;\n    font-weight: 500;\n}\n\n.panel-close-btn {\n    background: #f1f5f9;\n    border: none;\n    color: #64748b;\n    height: 40px;\n    width: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.panel-close-btn:hover {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n.history-panel-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n}\n\n.history-section-title {\n    margin: 0 0 1.5rem 0;\n    font-size: 1.1rem;\n    color: #475569;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.history-empty {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: #94a3b8;\n    text-align: center;\n    gap: 1rem;\n}\n\n.history-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.history-tx-card {\n    background: white;\n    border-radius: 12px;\n    padding: 1.25rem;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.history-tx-header {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 1rem;\n}\n\n.history-tx-icon {\n    height: 40px;\n    width: 40px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.bg-blue-light {\n    background: #eff6ff;\n}\n\n.bg-green-light {\n    background: #f0fdf4;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n.text-green {\n    color: #059669;\n}\n\n.history-tx-main {\n    flex: 1;\n}\n\n.history-tx-main h4 {\n    margin: 0 0 0.2rem 0;\n    font-size: 1.05rem;\n    color: #1e293b;\n    font-weight: 700;\n}\n\n.tx-date {\n    font-size: 0.85rem;\n    color: #64748b;\n}\n\n.history-tx-amount {\n    font-size: 1.2rem;\n    font-weight: 800;\n}\n\n.history-tx-details {\n    background: #f8fafc;\n    border-radius: 8px;\n    padding: 1rem;\n    font-size: 0.95rem;\n}\n\n.history-tx-details p {\n    margin: 0 0 0.4rem 0;\n    color: #334155;\n}\n\n.history-tx-details p:last-child {\n    margin: 0;\n}\n\n.history-tx-details strong {\n    color: #64748b;\n    font-weight: 600;\n}\n\n.history-pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    margin-top: 2rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e2e8f0;\n    font-weight: 600;\n    color: #475569;\n}\n\n/* === RESPONSIVE FOR MOBILE === */\n@media (max-width: 768px) {\n    .groups-header {\n        padding: 1.25rem;\n    }\n\n    .employees-main-content {\n        padding: 0 1rem 3rem 1rem;\n    }\n\n    .employees-control-panel {\n        justify-content: stretch;\n    }\n\n    .admin-search-form {\n        max-width: 100%;\n        width: 100%;\n    }\n\n    .elder-list-card {\n        flex-direction: column;\n        align-items: stretch;\n        padding: 1.25rem;\n        gap: 1.25rem;\n    }\n\n    .list-card-left {\n        width: 100%;\n    }\n\n    .list-card-right {\n        width: 100%;\n        border-top: 1px solid #f1f5f9;\n        padding-top: 1.25rem;\n    }\n\n    .view-history-btn {\n        width: 100%;\n        justify-content: space-between;\n    }\n\n    .elder-pagination {\n        flex-direction: column;\n        gap: 1.5rem;\n    }\n\n    .page-btn {\n        width: 100%;\n        justify-content: center;\n    }\n}\n\n\n/* === NEW: ADMIN TRANSFER HUB CARD === */\n.admin-transfer-hub-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid #a7f3d0;\n    box-shadow: 0 4px 10px rgba(16, 185, 129, 0.1);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1.5rem;\n    margin-bottom: 2.5rem;\n    transition: all 0.2s ease;\n}\n\n.admin-transfer-hub-card:hover {\n    box-shadow: 0 10px 15px -3px rgba(16, 185, 129, 0.2);\n    border-color: #34d399;\n}\n\n.hub-card-left {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    flex: 1;\n}\n\n.hub-card-info h2 {\n    margin: 0 0 0.25rem 0;\n    font-size: 1.4rem;\n    color: #064e3b;\n    font-weight: 800;\n}\n\n.hub-card-info p {\n    margin: 0;\n    color: #059669;\n    font-size: 1.05rem;\n}\n\n.bg-emerald-light {\n    background: #ecfdf5;\n}\n\n.text-emerald {\n    color: #059669;\n}\n\n@media (max-width: 768px) {\n    .admin-transfer-hub-card {\n        flex-direction: column;\n        align-items: stretch;\n        padding: 1.25rem;\n    }\n\n    .hub-card-right {\n        display: flex;\n        justify-content: flex-end;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
